import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import apiFetch from 'utils/apiFetch';
import MessagesIcon from 'assets/images/no_chats.svg';
import addLogo from 'assets/images/addLogo.svg';
import { TABLET_WIDTH } from 'constants/breakPoints';
import ChatRoom from 'components/ChatRoom';
import ChatElement from './ChatElement';
import FilterChat from './FilterChat';
import NewChat from './NewChat';
import {
  ChatListWrapper, ChatsList, CreateChat, CreateChatDesktop,
} from './styles';

class Chats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chats: [],
      update: false,
      createChat: false,
      filter: '',
      selectedChat: 0,
      numChats: 0,
    };
  }

  componentDidMount() {
    const { chats } = this.state;
    const { fetchChats } = this.props;
    if (!chats || chats.length === 0) {
      fetchChats();
    }
    this.setChats(true);
  }

  componentDidUpdate(prevProps) {
    const { userChats } = this.props;
    const { chats, update, numChats } = this.state;

    let found;
    const newMessages = [];
    if (prevProps.userChats && prevProps.userChats.length) {
      prevProps.userChats.forEach((chat) => {
        if (chat.last_message) {
          found = userChats.find(chat2 => chat2.id === chat.id);
          if (found.last_message.read) {
            newMessages.push(found);
          }
        }
      });
    }
    if (!update && newMessages.length > 0) {
      this.setState({ chats, update: true });
    }
    if (chats.length === 0 && userChats.length > 0) {
      this.setState({ chats, numChats: chats.length });
    }

    if (userChats.length !== numChats) {
      this.setChats();
    }
  }

  setChats = (setActiveChat) => {
    const { userChats } = this.props;
    const chatsUser = _.filter(userChats, chat => typeof chat.element_related === 'object' && typeof chat.element_related.type === 'undefined');

    chatsUser.sort((a, b) => {
      const aDate = a.last_message ? a.last_message.timestamp : a.timestamp;
      const bDate = b.last_message ? b.last_message.timestamp : b.timestamp;

      return aDate > bDate ? -1 : 1;
    });

    this.setState({ chats: chatsUser, numChats: userChats.length });

    if (chatsUser.length && setActiveChat) {
      this.setState({ selectedChat: chatsUser[0].id });
    }
  }


  handleClickChat = (chatId) => {
    if (window.outerWidth > TABLET_WIDTH) {
      this.setState({ selectedChat: chatId });
    } else {
      const { history } = this.props;
      history.push(`/chat/${chatId}`);
    }
  }

  handleClickMatch = (userId) => {
    const { addNewChat, history } = this.props;
    const params = {
      user: userId,
    };

    apiFetch('POST', { endPoint: 'chat' }, params)
      .then((chat) => {
        addNewChat(chat);
        history.push(`/chat/${chat.id}`);
      });
  }

  handleCreateChat = () => {
    this.setState({ createChat: true });
  }

  handleCloseCreateChat = () => {
    this.setState({ createChat: false });
  }

  filterChat = (value) => {
    this.setState({ filter: value });
  }

  printChats = () => {
    const { chats, filter } = this.state;
    const { app, user, literals } = this.props;

    const filteredChats = chats.filter(chat => _.isEmpty(chat.element_related));
    if (!filteredChats.length) {
      return (
        <div>
          <div className='no_elements'>
            <img src={MessagesIcon} alt={literals.noChatsAlt} />
            <div>{literals.noChats}</div>
          </div>
          <CreateChatDesktop color={app.color1} onClick={this.handleCreateChat} style={{ margin: '0 auto', maxWidth: '40rem' }}>
            +
            <span>{literals.newChat}</span>
          </CreateChatDesktop>
        </div>
      );
    }

    let chatRows = [];

    if (filter !== '') {
      const lowerFilter = filter.toLowerCase();

      chatRows = _.filter(filteredChats, (chat) => {
        const completeName = (`${chat.users[1].firstname} ${chat.users[1].lastname}`).toLowerCase();
        if (completeName.includes(lowerFilter)) {
          return true;
        }
        return false;
      });
    } else {
      chatRows = filteredChats;
    }

    const rows = chatRows.map((chat) => {
      return <ChatElement chat={chat} key={chat.id} onClick={this.handleClickChat} app={app} user={user} thinkChat={false} />;
    });

    return (
      <ChatsList>
        <div className='title_chats'>{literals.openChats}</div>
        {rows}
        <CreateChatDesktop color={app.color1} onClick={this.handleCreateChat}>
          +
          <span>{literals.newChat}</span>
        </CreateChatDesktop>
      </ChatsList>
    );
  }

  printCreateChatButton = () => {
    return (
      <CreateChat>
        <button onClick={this.handleCreateChat}>
          <img src={addLogo} alt='' />
        </button>
      </CreateChat>
    );
  }

  printFilterChat = () => {
    return (
      <FilterChat doFilter={this.filterChat} />
    );
  }

  printSelectedChat = () => {
    const { selectedChat } = this.state;
    if (!selectedChat || window.outerWidth <= TABLET_WIDTH) {
      return null;
    }

    return (
      <div className='selected_chat'>
        <ChatRoom chatId={selectedChat} />
      </div>
    );
  }

  onCreateChat = (chat) => {
    const { addNewChat } = this.props;

    addNewChat(chat);
    this.setState({ createChat: false }, () => {
      this.handleClickChat(chat.id);
    });
  }

  render() {
    const {
      app, literals, history, userConnections, userChats,
    } = this.props;
    const { createChat, selectedChat } = this.state;

    if (!createChat) {
      return (
        <React.Fragment>
          <ChatListWrapper color={app.color1} selectedChat={selectedChat}>
            {this.printFilterChat()}
            <div className='chat_grid'>
              <div className='chats_list'>{this.printChats()}</div>
              {this.printSelectedChat()}
            </div>
          </ChatListWrapper>
          {this.printCreateChatButton()}
        </React.Fragment>
      );
    }
    return (
      <NewChat chats={userChats} closeNewChat={this.handleCloseCreateChat} literals={literals} addNewChat={this.onCreateChat} history={history} userConnections={userConnections} />
    );
  }
}

Chats.propTypes = {
  literals: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  fetchChats: PropTypes.func.isRequired,
  userChats: PropTypes.array,
  userConnections: PropTypes.array.isRequired,
  addNewChat: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

Chats.defaultProps = {
  userChats: [],
};

export default Chats;



// WEBPACK FOOTER //
// ./src/components/Chats/components/index.jsx